import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const DraggingFormantInfo = ({height, formant, frequency}) => { 
    return (
        <div style={{height: height.current || 20}} className="dragging-formant-info">
          {frequency} hz
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let freq = props.formant.formantFrequencyParameter.id;
  return {
      frequency: Math.round(state.effects.effectParameters[freq])
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DraggingFormantInfo);
